<template>
    <div class="container">
        <div class="row advisor-search-page-name floating-label" v-bind:class="{'has-focus is-floating': focused}" id="advisor-search-by-name" role="tabpanel" aria-labelledby="advisor-search-page-tab_by_name" tabindex="0">
          <span class="pill large">
            <label class="search-name-label" for="advisorName-id-field">{{placeholder}}</label>
            <input id="advisorName-id-field" type="text" v-model="name" v-on:keyup.enter="setName" v-on:focus="focused=true" v-on:blur="handleBlur" aria-label="Search by name" v-bind:aria-describedby="showError ? 'error-search-by-name': ''" />
            <button v-on:click.stop="setName" class="advisor-search-container__filters-search "><img src="/Static/assets/images/search_icon_red.svg" alt="search" /></button>
          </span>
        </div>
        <div class="row" v-if="showError">
            <div class="col-12">
                <p class="text-danger" id="error-search-by-name">{{ text("advisorSearchByNameError") }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import EventBus from "../functions/eventBus";
import { locText } from "../../../utils/useText";

export default {
    data() {
        return {
            name: null,
            showError: false,
            focused: false
        }
    },
    created() {
        if (this.presetType) {
            this.userType = this.presetType;
        }
    },
    computed: {
        placeholder: {
            get() {
                return this.text('advisorSearchNamePlaceholder');
            }
        },
        userSearch: {
            get() {
                return this.$store.getters.userSearchName;
            },
            set(value) {
                this.updateUserSearchName({
                    name: value,
                    wealth: this.presetType == "Wealth Advisor"
                });
            }
        },
        userType: {
            get() {
                return this.$store.getters.userType;
            },
            set(value) {
                this.updateUserType(value);
            }
        },
        isDirectConsumer: {
            get() {
                return this.$store.getters.isDirectConsumer;
            },
            set(value) {
                this.updateDirectConsumer(value);
            }
        }
    },
    methods: {
        ...mapActions(["updateUserSearchName", "updateUserType", "updateDirectConsumer"]),

        setName() {
            if(this.name) {
              this.isDirectConsumer = false;
                if (typeof HERO_analytics_data_layer != "undefined") {
                    let analytics = HERO_analytics_data_layer,
                        searchTerm = this.name,
                        event = {
                            event: "search",
                            search__type: this.tabTitle,
                            search__term: searchTerm,
                        };
                    analytics.pushEventAndData(event);
                }
                this.userSearch = this.name;

            }
            else {
                this.showError = true;
            }
      },
      handleBlur() {
        if (this.name) {
          this.focused = true;
        } else {
          this.focused = false;
        }
      }
    },
    mixins: [locText],
    props: {
        presetType: String,
        tabTitle: String
    }
}
</script>
